import { render } from "./YachtsAdmin.vue?vue&type=template&id=2d224e86&scoped=true"
import script from "./YachtsAdmin.vue?vue&type=script&lang=ts"
export * from "./YachtsAdmin.vue?vue&type=script&lang=ts"

import "./YachtsAdmin.vue?vue&type=style&index=0&id=2d224e86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d224e86"

export default script